<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.90002 8.06023C9.21002 4.46023 11.06 2.99023 15.11 2.99023H15.24C19.71 2.99023 21.5 4.78023 21.5 9.25023V15.7702C21.5 20.2402 19.71 22.0302 15.24 22.0302H15.11C11.09 22.0302 9.24002 20.5802 8.91002 17.0402"
    stroke="#E4E7EB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M2 12.5H14.88" stroke="#E4E7EB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.65 9.1499L16 12.4999L12.65 15.8499" stroke="#E4E7EB" stroke-width="1.5" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>